/*
 * Katana cart — add-to-cart handling for the chrome basket.
 * Intercepts any form posting to /cart/add and adds the item over AJAX. On
 * success the basket pulses once, the counter updates, and the page navigates
 * to the cart.
 */
(function () {
  'use strict';

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function cartIcon() {
    return document.querySelector('[data-kcart-icon]');
  }

  function setCount(count) {
    var badge = document.querySelector('[data-kcart-count]');
    if (badge) badge.textContent = count > 0 ? String(count) : '';
  }

  /* Pulse the basket once. */
  function pulse() {
    var icon = cartIcon();
    if (!icon || reducedMotion.matches) return;
    var glyph = icon.querySelector('.katana-cart__icon');
    icon.classList.add('is-pulsing');
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      icon.classList.remove('is-pulsing');
    };
    if (glyph) glyph.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 600); // safety if animationend never fires
  }

  function handleSubmit(e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!cartIcon()) return; // no chrome basket on this page — normal submit
    if (form.dataset.kflyBusy === '1') {
      e.preventDefault();
      return;
    }

    e.preventDefault();

    var submitter = e.submitter || form.querySelector('[type="submit"]') || form;
    var body = new FormData(form);
    if (e.submitter && e.submitter.name) body.append(e.submitter.name, e.submitter.value);

    form.dataset.kflyBusy = '1';
    if (submitter && submitter.tagName === 'BUTTON') submitter.disabled = true;

    // Where to land the shopper once the item is in — the cart page, matching
    // the native /cart/add form's default redirect.
    var destination = routeRoot + 'cart';

    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: body
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        return fetch(routeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return cart.item_count || 0; });
      })
      .then(function (count) {
        // Pulse the basket, bump the counter, then navigate to the cart.
        pulse();
        setCount(count);
        setTimeout(function () {
          window.location.assign(destination);
        }, reducedMotion.matches ? 0 : 300);
      })
      .catch(function () {
        // AJAX failed (e.g. sold out race, network) — fall back to a real submit.
        form.dataset.kflyBusy = '';
        if (submitter && submitter.tagName === 'BUTTON') submitter.disabled = false;
        form.submit();
      });
  }

  document.addEventListener('submit', handleSubmit);
})();
